import React from "react";

const InformationalBox = ({
  content,
  jsxContent,
  boxNewStyles,
  contentNewStyles,
  showIcon,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          background: "#cce5ff",
          borderColor: "#b8daff",
          border: "1px solid transparent",
          borderRadius: ".25rem",
          ...boxNewStyles,
        }}
      >
        {showIcon ? (
          <img
            style={{
              width: "25px",
              height: "2.5rem",
              marginLeft: "15px",
            }}
            src={`/img/info_icons/info-information.svg`}
            alt=""
          />
        ) : null}
        {jsxContent ? (
          jsxContent
        ) : (
          <p
            style={{
              fontSize: "12px",
              color: "#004085",
              padding: ".5rem",
              ...contentNewStyles,
            }}
          >
            {content}
          </p>
        )}
      </div>
    </>
  );
};

export default InformationalBox;
